const SET_TITLE = 'SET_TITLE';
const SET_STEP = 'SET_STEP';
const SET_STATUS = 'SET_STATUS';
const SET_SUBTITLE = 'SET_SUBTITLE';
const SET_NO_MOSTRAR = 'SET_NO_MOSTRAR';
const SET_PENDING_RISK = 'SET_PENDING_RISK';
const SET_ALL_PENDING_RISK = 'SET_ALL_PENDING_RISK';
const SET_TAREA = 'SET_TAREA';
const DELETE_PENDING_RISK = 'DELETE_PENDING_RISK';

const state = {
  step_anual: 1,
  tarea_vista: '',
  all_risk_pending: null,
  riesgos_pendientes: null,
  status: '',
  noMostrar: true,
  title: '',
  subtitle: '',
  colorRisks: {
    salud: 'rgb(0, 167, 245)',
    seguridad: 'rgb(179, 167, 0)',
    medioambiente: 'rgb(40, 134, 98)',
    personalizados: 'rgb(227, 0, 82)',
  },
};

const getters = {
  step_anual: state => state.step_anual,
  tarea_vista: state => state.tarea_vista,
  all_risk_pending: state => state.all_risk_pending,
  riesgos_pendientes: state => state.riesgos_pendientes,
  noMostrar: state => state.noMostrar,
  title: state => state.title,
  status: state => state.status,
  subtitle: state => state.subtitle,
  colorSalud: state => state.colorRisks.salud,
  colorSeguridad: state => state.colorRisks.seguridad,
  colorMedioambiente: state => state.colorRisks.medioambiente,
  colorPersonalizado: state => state.colorRisks.personalizados,
};

const actions = {
  setStep({ commit }, step) {
    commit(SET_STEP, step);
  },
  setTitle({ commit }, newTitle) {
    commit(SET_TITLE, newTitle);
  },

  setStatus({ commit }, newStatus) {
    commit(SET_STATUS, newStatus);
  },

  setSubTitle({ commit }, newSubTitle) {
    commit(SET_SUBTITLE, newSubTitle);
  },

  setTareaVista({ commit }, newtarea) {
    commit(SET_TAREA, newtarea);
  },

  setNoMostrar({ commit }, estado) {
    commit(SET_NO_MOSTRAR, estado);
  },

  setRiesgosPendientes({ commit }, riesgos) {
    commit(SET_PENDING_RISK, riesgos);
  },

  deleteRiesgosPendientes({ commit }, id_risk) {
    commit(DELETE_PENDING_RISK, id_risk);
  },

  setAllRiesgosPendientes({ commit }, riesgos) {
    commit(SET_ALL_PENDING_RISK, riesgos);
  },
};

const mutations = {
  [SET_TAREA](state, tarea) {
    state.tarea_vista = tarea;
  },
  [SET_TITLE](state, title) {
    state.title = title;
  },
  [SET_STEP](state, step) {
    state.step_anual = step;
  },
  [SET_PENDING_RISK](state, riesgos) {
    state.riesgos_pendientes = riesgos;
  },
  [DELETE_PENDING_RISK](state, id_risk) {
    const pos = state.riesgos_pendientes.risks.map(e => e.id_riesgo).indexOf(id_risk);
    if (pos !== -1) {
      state.riesgos_pendientes.risks.splice(pos, 1);
    }
  },
  [SET_ALL_PENDING_RISK](state, riesgos) {
    state.all_risk_pending = riesgos;
  },
  [SET_STATUS](state, status) {
    state.status = status;
  },
  [SET_SUBTITLE](state, subtitle) {
    state.subtitle = subtitle;
  },
  [SET_NO_MOSTRAR](state, estado) {
    state.noMostrar = estado;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
